<template>
    <div class="container-login">

        <div class="info">
        </div>
        <div class="form">

            <div class="content-form reset-text-transform">

                <div class="login-icon">
                    <i class="fas fa-user"></i>
                </div>

                <el-form @submit.native.prevent="onSubmitLogin" :model="dados" ref="dados" label-position="top" class="u-mt-10 form-login">
                    <el-row :gutter="10" type="flex" justify="center">
                        <el-col :xs="22" :sm="22" :md="22">
                            <el-form-item prop="username" :rules="[$requiredBlur]" key="username" label="Usuário">
                                <el-input class="input-login" size="large" id="username" v-model="dados.username" clearable>
                                    <template #prepend>
                                        <i class="fas fa-user"></i>
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" type="flex" justify="center">
                        <el-col :xs="22" :sm="22" :md="22">
                            <el-form-item prop="password" :rules="[$requiredBlur]" key="password" label="Senha">
                                <el-input class="input-login" size="large" id="password" type="password" v-model="dados.password" clearable>
                                    <template #prepend>
                                        <i class="fas fa-lock"></i>
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="1" type="flex" justify="center" style="display: none;">
                        <el-col :xs="24" :sm="10" :md="10">
                            <el-checkbox class="checkbox-custom" v-model="checked">Manter conectado</el-checkbox>
                        </el-col>
                        <el-col :xs="24" :sm="10" :md="10" class="forgot-password-col-login">
                            <span class="forgot-password-option-login">esqueceu a senha?</span>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" type="flex" justify="center">
                        <el-col :xs="24" :sm="24" :md="24">
                            <div class="u-text-center">
                                <el-button size="medium" :loading="loading" class="btn-login" type="primary" native-type="submit" plain>
                                    <span v-if="!loading">Login</span>
                                </el-button>
                            </div>
                        </el-col>
                    </el-row>

                </el-form>

            </div>
            <div class="login-logo">
                <img src="/public/img/logo-white.png" alt="logo">
            </div>
        </div>

    </div>
</template>
<script>

import axios from 'axios'

export default {
  data() {
      return {
          loading: false,
          checked: false,
          dados: {
              username: '',
              password: '',
              lembre_me: false
          },
      };
  },
  mounted () {

      sessionStorage.removeItem('ed543672Instituicao');
      sessionStorage.removeItem('ed543672Token');
  },
  methods: {
    createLog(){

      let dados = {ocorrencia: 'logou no sistema' };

      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/log/store`, dados, this.$store.getters.getHeaderAuth).then(response => {

        this.$router.push("admin");

      }).catch((error) => { this.$store.commit('throwException', error); this.loading = false; });

    },
    onSubmitLogin() {

        this.$refs.dados.validate((valid) =>{ if(valid){

            this.loading = true;

            axios.post(`${this.$store.state.config.baseUrlApi}/oauth/token`, this.dados, this.$store.getters.getHeader).then(response => {

                this.$store.commit('setToken', response.data.access_token);
                sessionStorage.setItem('ed543672Token', response.data.access_token);
                this.createLog();

            }).catch((error) => {

                try{

                    this.loading = false;

                    if(error.response.status == '401'){

                    this.$message({
                        message: 'Erro! Usuário não autorizado.',
                        type: 'error',
                        duration: 5000
                    });

                    }else if(error.response.status == '429'){

                    this.$message({
                        message: 'Erro! Demasiadas solicitações em curto período de tempo.',
                        type: 'error',
                        duration: 5000
                    });

                    }else{

                    this.$message({
                        message: 'Erro! Não foi possível realizar o login.',
                        type: 'error',
                        duration: 5000
                    });

                    }

                }catch(e){

                    this.loading = false;

                    this.$message({
                        message: 'Erro! Não foi possível realizar o login.',
                        type: 'error',
                        duration: 5000
                    });

                }

            });
        }});
      }
  },
};
</script>
